import client from "../../../../client";
import type { RequestConfig, ResponseErrorConfig } from "../../../../client";
import type {
  PostApiForgotValidatechallengeMutationRequest,
  PostApiForgotValidatechallengeMutationResponse,
  PostApiForgotValidatechallenge401,
  PostApiForgotValidatechallenge403,
} from "../../../types/PostApiForgotValidatechallenge";

export function getPostApiForgotValidatechallengeUrl() {
  return `/api/Forgot/ValidateChallenge` as const;
}

/**
 * {@link /api/Forgot/ValidateChallenge}
 */
export async function postApiForgotValidatechallenge(
  data?: PostApiForgotValidatechallengeMutationRequest,
  config: Partial<
    RequestConfig<PostApiForgotValidatechallengeMutationRequest>
  > & { client?: typeof client } = {}
) {
  const { client: request = client, ...requestConfig } = config;

  const res = await request<
    PostApiForgotValidatechallengeMutationResponse,
    ResponseErrorConfig<
      PostApiForgotValidatechallenge401 | PostApiForgotValidatechallenge403
    >,
    PostApiForgotValidatechallengeMutationRequest
  >({
    method: "POST",
    url: getPostApiForgotValidatechallengeUrl().toString(),
    data,
    ...requestConfig,
    headers: { "Content-Type": "application/*+json", ...requestConfig.headers },
  });
  return res;
}
